// Estilo
import style from './labelLogo.module.css'

// Datos
import LOGO from "../../../assets/imgs/logo.png";

function LabelLogo(){
    return (
        <img src={LOGO} id={style.logo}/>
    )
}

export default LabelLogo;